export default __webpack_public_path__ + "static/media/AllrfpLightInActive.ad229ed1.svg";